"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _objectSpread = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _excluded = ["custom"];
var _filter;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnboardProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@web3-onboard/react");
var injected_wallets_1 = __importDefault(require("@web3-onboard/injected-wallets"));
var walletconnect_1 = __importDefault(require("@web3-onboard/walletconnect"));
var coinbase_1 = __importDefault(require("@web3-onboard/coinbase"));
var react_2 = require("react");
var customwalletconnect_1 = require("./modules/customwalletconnect");
var lodash_1 = require("lodash");
var injected = (0, injected_wallets_1.default)({
  filter: (_filter = {}, _defineProperty(_filter, "Binance Smart Wallet", false), _defineProperty(_filter, "MetaMask", true), _defineProperty(_filter, "Coinbase Wallet", true), _defineProperty(_filter, "detected", true), _defineProperty(_filter, "trust", false), _defineProperty(_filter, "opera", false), _defineProperty(_filter, "status", false), _defineProperty(_filter, "alphawallet", false), _defineProperty(_filter, "atoken", false), _defineProperty(_filter, "bitpie", false), _defineProperty(_filter, "blockwallet", false), _defineProperty(_filter, "Brave", false), _defineProperty(_filter, "dcent", false), _defineProperty(_filter, "frame", false), _defineProperty(_filter, "huobiwallet", false), _defineProperty(_filter, "hyperpay", false), _defineProperty(_filter, "imtoken", false), _defineProperty(_filter, "liquality", false), _defineProperty(_filter, "meetone", false), _defineProperty(_filter, "ownbit", false), _defineProperty(_filter, "mykey", false), _defineProperty(_filter, "tokenpocket", false), _defineProperty(_filter, "tp", false), _defineProperty(_filter, "xdefi", false), _defineProperty(_filter, "oneInch", false), _defineProperty(_filter, "tokenary", false), _defineProperty(_filter, "tally", false), _filter)
});
var defaultWc = (0, walletconnect_1.default)({
  bridge: "https://bridge.walletconnect.org",
  qrcodeModalOptions: {
    mobileLinks: ["rainbow", "metamask", "argent", "trust", "imtoken", "pillar"]
  },
  connectFirstChainId: false
});
var coinbaseWalletSdk = (0, coinbase_1.default)();
var zenGoWc = (0, customwalletconnect_1.customWcModule)({
  customLabelFor: "zengo",
  bridge: "https://bridge.walletconnect.org",
  qrcodeModalOptions: {
    desktopLinks: ["zengo", "metamask"],
    mobileLinks: ["metamask", "zengo"] // TODO: has to be tested on IOS, android does not show list
  },

  connectFirstChainId: false
});
var gdWc = (0, customwalletconnect_1.customWcModule)({
  customLabelFor: "gooddollar",
  bridge: "https://bridge.walletconnect.org",
  connectFirstChainId: false
});
var defaultOptions = {
  chains: [{
    id: "0xa4ec",
    token: "CELO",
    label: "CELO Testnet",
    rpcUrl: "https://alfajores-forno.celo-testnet.org",
    namespace: "evm"
  }]
};
var defaultWalletsFlags = {
  gooddollar: true,
  metamask: true,
  walletconnect: true,
  coinbase: true,
  zengo: true,
  custom: []
};
var walletsMap = {
  gooddollar: gdWc,
  metamask: injected,
  walletconnect: defaultWc,
  coinbase: coinbaseWalletSdk,
  zengo: zenGoWc
};
var OnboardProvider = function OnboardProvider(_ref) {
  var _ref$options = _ref.options,
    options = _ref$options === void 0 ? defaultOptions : _ref$options,
    _ref$wallets = _ref.wallets,
    wallets = _ref$wallets === void 0 ? null : _ref$wallets,
    children = _ref.children;
  var onboardRef = (0, react_2.useRef)();
  // initialise once at first render
  (function () {
    if (onboardRef.current) {
      return;
    }
    var _defaultWalletsFlags = _objectSpread(_objectSpread({}, defaultWalletsFlags), wallets || {}),
      _defaultWalletsFlags$ = _defaultWalletsFlags.custom,
      custom = _defaultWalletsFlags$ === void 0 ? [] : _defaultWalletsFlags$,
      flags = _objectWithoutProperties(_defaultWalletsFlags, _excluded);
    var selectedWallets = (0, lodash_1.keys)((0, lodash_1.pickBy)(flags));
    // TODO: add option to define order when custom wallets are added
    onboardRef.current = (0, react_1.init)(_objectSpread(_objectSpread({}, options), {}, {
      wallets: [].concat(_toConsumableArray(custom), _toConsumableArray(selectedWallets.map(function (key) {
        return walletsMap[key];
      })))
    }));
  })();
  return (0, jsx_runtime_1.jsx)(react_1.Web3OnboardProvider, {
    web3Onboard: onboardRef.current,
    children: children
  });
};
exports.OnboardProvider = OnboardProvider;